import { ICountry } from '@dash/country';
import { languages } from '../i18n/config';

export const COUNTRIES: { [key: string]: ICountry } = {
  USA: {
    code: 'USA',
    currency: 'USD',
    currency_symbol: '$',
    alpha_2_code: 'US',
    name: 'USA',
    locale: languages.en_US,
    dir: 'ltr',
    timezone: 'America/New_York',
    googleLanguage: 'en',
    phone: {
      mask: '+1 999-999-9999',
      countryCallingCode: '1',
    },
    flag: 'usa',
    defaultAddress: {
      city: 'New York',
      lat: 40.73061,
      lng: -73.935242,
    },
  },
  AUS: {
    code: 'AUS',
    currency: 'AUD',
    currency_symbol: '$',
    alpha_2_code: 'AU',
    name: 'Australia',
    locale: languages.en_AU,
    dir: 'ltr',
    timezone: 'Australia/Sydney',
    googleLanguage: 'en',
    phone: {
      mask: '+61 999 999 999',
      countryCallingCode: '61',
    },
    flag: 'aus',
    defaultAddress: {
      city: 'Sydney',
      lat: -33.836944,
      lng: 151.087933,
    },
  },
  ISR: {
    code: 'ISR',
    currency: 'ILS',
    currency_symbol: '₪',
    alpha_2_code: 'IL',
    name: 'Israel',
    locale: languages.he_IL,
    dir: 'rtl',
    timezone: 'Asia/Jerusalem',
    googleLanguage: 'he',
    phone: {
      mask: '+972 999 9999 99',
      countryCallingCode: '972',
    },
    flag: 'isr',
    defaultAddress: {
      city: 'Jerusalem',
      lat: 31.7683,
      lng: 35.2137,
    },
    nationalIdMask: '999999999',
  },
  GBR: {
    code: 'GBR',
    currency: 'GBP',
    currency_symbol: '£',
    alpha_2_code: 'GB',
    name: 'GBR',
    locale: languages.en_GB,
    dir: 'ltr',
    timezone: 'Europe/London',
    googleLanguage: 'en',
    phone: {
      mask: '+44 99-9999-9999',
      countryCallingCode: '44',
    },
    flag: 'gbr',
    defaultAddress: {
      city: 'London',
      lat: 51.501597,
      lng: -0.119783,
    },
  },
};
